const ar = {
  // Hero Section
  hero: {
    title: "رفيقك الطبي",
    titleHighlight: "الذكي",
    subtitle: "المتخصص",
    description:
      "قم بتبسيط إدارة المرضى والمواعيد والسجلات الطبية باستخدام لوحة معلومات RAQIB الشاملة للرعاية الصحية.",
    buttonGetStarted: "اشتروا الآن",
    buttonWatchDemo: "شاهد العرض التوضيحي",
  },

  // Features Section
  features: {
    sectionTitle: "إدارة شاملة للرعاية الصحية",
    sectionDescription:
      "يوفر RAQIB جميع الأدوات التي تحتاجها لإدارة ممارستك الطبية بكفاءة وتقديم رعاية استثنائية للمرضى.",
    items: [
      {
        emoji: "👨‍⚕️",
        title: "إدارة المرضى",
        description:
          "ملفات شاملة للمرضى مع السجل الطبي والحساسية والأدوية وخطط العلاج كلها في مكان واحد.",
      },
      {
        emoji: "📅",
        title: "جدولة ذكية",
        description:
          "نظام تعيين حدسي مع تذكيرات آلية لتقليل عدم المقارنة وتحسين جدولك الزمني.",
      },
      {
        emoji: "💊",
        title: "إدارة الوصفات",
        description:
          "إنشاء وتتبع وإدارة الوصفات الطبية رقميًا مع التكامل مع الصيدليات.",
      },
      {
        emoji: "📊",
        title: "التحليلات الطبية",
        description:
          "تحليلات قوية لتتبع نتائج المرضى وأداء العيادة والمقاييس المالية.",
      },
      {
        emoji: "💳",
        title: "الفواتير والتأمين",
        description:
          "عملية فواتير مبسطة مع دعم مطالبات التأمين وتتبع الدفع.",
      },
      {
        emoji: "🛡️",
        title: "متوافق مع HIPAA",
        description:
          "الأمان والامتثال على مستوى المؤسسة لحماية معلومات صحة المرضى الحساسة.",
      },
    ],
  },

  // Demo Video Section
  demoVideo: {
    title: "شاهد RAQIB قيد التنفيذ",
    description:
      "شاهد عرضنا التوضيحي لمدة دقيقتين لترى كيف يمكن لـ RAQIB أن يحول إدارة ممارستك الطبية.",
    benefits: [
      "قلل عبء العمل الإداري بنسبة 60٪",
      "تحسين رضا المرضى من خلال تجربة سلسة",
      "الوصول إلى بيانات المريض الحرجة في أي وقت وفي أي مكان",
    ],
    videoDemoTitle: "عرض منصة RAQIB",
  },

  // Testimonials Section
  testimonials: {
    sectionTitle: "موثوق من قبل المتخصصين في الرعاية الصحية",
    items: [
      {
        initials: "DR",
        name: "د. سارة جونسون",
        title: "أخصائي أمراض القلب، مستشفى المدينة",
        text: "لقد غيّر RAQIB الطريقة التي نتعامل بها مع رعاية المرضى. يوفر الواجهة البديهية لنا ساعات كل أسبوع، مما يسمح لنا بالتركيز على ما يهم حقًا - مرضانا.",
        rating: 5,
      },
      {
        initials: "NP",
        name: "الممرضة بريا باتيل",
        title: "ممارس التمريض",
        text: "تتبع الأدوية وميزات الوصفات الطبية غيرا قواعد اللعبة. يمكنني الآن إدارة جميع أدوية مرضاي دون القلق بشأن الأخطاء.",
        rating: 5,
      },
      {
        initials: "AM",
        name: "أليكس مورجان",
        title: "مسؤول العيادة",
        text: "كان عملية الفواتير المالية تستغرق أيامًا. باستخدام RAQIB، نكمله في غضون ساعات. تساعدنا ميزات البلاغات في اتخاذ قرارات تستند إلى البيانات لممارستنا.",
        rating: 4,
      },
    ],
  },

 

  // Pricing Section
  pricing: {
    sectionTitle: "التسعير البسيط والشفاف",
    description:
      "اختر الخطة التي تناسب احتياجات ممارستك. لا توجد رسوم مخفية، قم بالإلغاء في أي وقت.",
  },

  // CTA Section
  cta: {
    title: "هل أنت مستعد لتحويل ممارستك الطبية؟",
    description:
      "انضم إلى آلاف المتخصصين في الرعاية الصحية الذين يثقون بـ RAQIB لاحتياجات إدارة ممارستهم.",
    buttonStartTrial: "ابدأ نسختك التجريبية المجانية",
    buttonScheduleDemo: "جدولة عرض توضيحي",
  },
};

export default ar;
